import {CONSTANTS} from '../Api/Constants'
import "chartjs-plugin-datalabels";
import moment from "moment";

export const Epoch = (date) => {
    return Math.round(new Date(date).getTime() / 1000.0);
}

export const FindShift = (date) => {

    let shift;
    const hours = date.getHours();
    if (hours >= 0 && hours < 8) {
        shift = 1;
    } else if (hours >= 8 && hours < 16) {
        shift = 2;
    } else {
        shift = 3;
    }
    return shift;

}

export const ValidateColor = (processValue) => {
  
    let status;
    if (processValue >= 90) {
      // Green
      status = "#3cc480";
    } else if (processValue > 60 && processValue < 90) {
      // Yellow
      status = "#ffc60a";
    } else if (processValue <= 60) {
      // Red
      status = "#ff5544";
    }
    return status;
  };

export const isToday = (dateParameter) => {
  var today = new Date();
  return dateParameter.getDate() === today.getDate() && dateParameter.getMonth() === today.getMonth() && dateParameter.getFullYear() === today.getFullYear();
}

export const startOfTheDay = (updatedValue) => moment(updatedValue).hours(CONSTANTS.SHIFT.STARTHOUR).minutes(CONSTANTS.SHIFT.STARTMIN).seconds(CONSTANTS.SHIFT.STARTSEC).unix();
export const endOfTheDay = (updatedValue) => moment(updatedValue).hours(CONSTANTS.SHIFT.ENDHOUR).minutes(CONSTANTS.SHIFT.ENDMIN).seconds(CONSTANTS.SHIFT.ENDSEC).unix();

export const epochToJsDate = (ts) => {
  return new Date(ts*1000);
}

export const jsDateToEpoch = (d) => {
  return (d.getTime()-d.getMilliseconds())/1000;
}

export const scrapRateFirstPassOptions = {
  scales: {
    x: {
      display: false,
      ticks: {
        display: false,
      },
    },
    y: {
      display: false,
      ticks: {
        display: false,
      },
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "rgb(255, 255, 255)",
      titleColor: "#000000",
      borderColor: "#eaeaea",
      borderWidth: "1",
      callbacks: {
        labelTextColor: function (context) {
          return "#333333";
        },
        label: (data) => { 
          return data.formattedValue + '%';
        }
      },
    },
  },
};

export const printerOptions = {
  scales: {
    x: {
      display: true,
      ticks: {
        display: true,
      },
    },
    y: {
      display: true,
      ticks: {
        display: true,
      },
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "rgb(255, 255, 255)",
      titleColor: "#000000",
      borderColor: "#eaeaea",
      borderWidth: "1",
      callbacks: {
        labelTextColor: function (context) {
          return "#333333";
        },
        label: (data) => { 
          return data.formattedValue + 'sec';
        }
      },
    },
  },
};

export const topTrueDefectsOptions = {
  scales: {
    x: {
      display: true,
      ticks: {
        display: true,
      },
    },
    y: {
      display: true,
      ticks: {
        display: true,
      },
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "rgb(255, 255, 255)",
      titleColor: "#000000",
      borderColor: "#eaeaea",
      borderWidth: "1",
      callbacks: {
        labelTextColor: function (context) {
          return "#333333";
        },
        label: (data) => { 
          return data.formattedValue;
        }
      },
    },
  },
};

export const topTrueDefectsOptionsYPos = {
  indexAxis: 'y',
  scales: {
    x: {
      display: true,
      ticks: {
        display: true,
      },
      grid: {
        display: false
      }
    },
    y: {
      display: true,
      grid: {
        display: false
      },
      ticks: {
        display: true,
        beginAtZero: true,
        steps: 10,
        stepValue: 5,
        max: 100
      },
    },
  },
  plugins: {
    datalabels: {
      display: true,
      color: "white"
    },
    legend: { display: false },
    tooltip: {
      backgroundColor: "rgb(255, 255, 255)",
      titleColor: "#000000",
      borderColor: "#eaeaea",
      borderWidth: "1",
      callbacks: {
        labelTextColor: function (context) {
          return "#333333";
        },
        label: (data) => { 
          return data.formattedValue;
        }
      },
    },
  },
};

export const lineScrapDPMChartOptions = {
  scales: {
    x: {
      display: false,
      ticks: {
        display: false,
      },
    },
    y: {
      display: false,
      ticks: {
        display: false,
      },
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "rgb(255, 255, 255)",
      titleColor: "#000000",
      borderColor: "#eaeaea",
      borderWidth: "1",
      callbacks: {
        labelTextColor: function (context) {
          return "#333333";
        },
        label: (data) => { 
          return data.formattedValue;
        }
      },
    },
  },
};

export const factoryStartTime = () => {
  let sday = new Date()
  let sH = parseInt(sday.getHours() + '' + ('0'+sday.getMinutes()).slice(-2))
  let cH = parseInt(CONSTANTS.SHIFT.STARTHOUR + '' + CONSTANTS.SHIFT.STARTMIN)

  if (sH < cH) sday.setDate(sday.getDate() - 1)
  
  sday.setHours(CONSTANTS.SHIFT.STARTHOUR)
  sday.setMinutes(CONSTANTS.SHIFT.STARTMIN)
  sday.setSeconds(CONSTANTS.SHIFT.STARTSEC)
  return sday;
}

export const factoryEndTime = () => {
  let eday = new Date()
  let sH = parseInt(eday.getHours() + '' + ('0'+ eday.getMinutes()).slice(-2))
  let cH = parseInt(CONSTANTS.SHIFT.ENDHOUR + '' + CONSTANTS.SHIFT.ENDMIN)
  
  if (cH < sH) eday.setDate(eday.getDate() + 1 )
  
  eday.setHours(CONSTANTS.SHIFT.ENDHOUR)
  eday.setMinutes(CONSTANTS.SHIFT.ENDMIN)
  eday.setSeconds(CONSTANTS.SHIFT.ENDSEC)
  return eday;
}

export const factoryStartEndTime = () => {
  let sday = new Date()
  let sH = parseInt(sday.getHours() + '' + ('0'+sday.getMinutes()).slice(-2))
  let eday = new Date()
  let eH = parseInt(eday.getHours() + '' + ('0'+eday.getMinutes()).slice(-2))
  let cH = parseInt(CONSTANTS.SHIFT.STARTHOUR + '' + CONSTANTS.SHIFT.STARTMIN)

  if (sH < cH) sday.setDate(sday.getDate() - 1)
  
  sday.setHours(CONSTANTS.SHIFT.STARTHOUR)
  sday.setMinutes(CONSTANTS.SHIFT.STARTMIN)
  sday.setSeconds(CONSTANTS.SHIFT.STARTSEC)
  
  let startTime = moment(sday).hours(CONSTANTS.SHIFT.STARTHOUR).minutes(CONSTANTS.SHIFT.STARTMIN).seconds(CONSTANTS.SHIFT.STARTSEC).unix();
  
  if (cH < eH) eday.setDate(eday.getDate() + 1 )
  
  eday.setHours(CONSTANTS.SHIFT.ENDHOUR)
  eday.setMinutes(CONSTANTS.SHIFT.ENDMIN)
  eday.setSeconds(CONSTANTS.SHIFT.ENDSEC)
  
  let endTime = moment(eday).hours(CONSTANTS.SHIFT.ENDHOUR).minutes(CONSTANTS.SHIFT.ENDMIN).seconds(CONSTANTS.SHIFT.ENDSEC).unix();
  
  return {'startTs': startTime, 'endTs': endTime};
}